export const discountHistoryKeys = {
  all: ['discount-history'] as const,
  lists: () => [...discountHistoryKeys.all, 'list'] as const,
  list: (hostId: number, page: number, perPage: number) =>
    [...discountHistoryKeys.lists(), { hostId, page, perPage }] as const,
};
